module.exports = __webpack_public_path__ + "static/media/loading-logo-loop.gif";